<h1 mat-dialog-title>{{'Zmena hesla' | translate}}</h1>
<hr/>
<div mat-dialog-content class="alert p-3 m-3 rounded">
    <form #passwordForm="ngForm">
        <div class="mb-3">
            <label for="passwordOld" class="form-label">{{'Staré heslo' | translate}}</label>
            <input type="password" class="form-control" id="passwordOld" name="passwordOld"
                   [(ngModel)]="model.passwordOld" required cdkFocusInitial
            >
        </div>
        <div class="mb-3">
            <label for="passwordNew1" class="form-label">{{'Nové heslo' | translate}}</label>
            <input
                type="password" class="form-control" id="passwordNew1" name="passwordNew1"
                [(ngModel)]="model.passwordNew1" required
            >
        </div>
        <div class="mb-3">
            <label for="passwordNew2" class="form-label">{{'Nové heslo' | translate}}</label>
            <input
                type="password" class="form-control" id="passwordNew2" name="passwordNew2"
                [(ngModel)]="model.passwordNew2"
                required
                [ngClass]="{'error': model.passwordNew1 !== model.passwordNew2}"
            >
        </div>
        <div *ngIf="model.passwordNew1 !== model.passwordNew2">
            <span class="text-danger small">{{'Heslá sa nezhodujú!' | translate}}</span>
        </div>
    </form>
</div>
<hr/>
<div mat-dialog-actions class="d-flex justify-content-end">
    <button class="btn" mat-button [mat-dialog-close]="'KO'">{{'Zrušiť' | translate}}</button>
    <button class="btn" mat-button (click)="passwordChange()">{{'Uložiť' | translate}}</button>
</div>
